"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderWarningQueryResult = void 0;
function renderWarningQueryResult(renderData, renderLoading) {
    return {
        renderError: function (_) { return null; },
        renderDataWithError: function (_) { return null; },
        renderNoData: function () { return null; },
        renderData: renderData,
        renderLoading: renderLoading,
    };
}
exports.renderWarningQueryResult = renderWarningQueryResult;
//# sourceMappingURL=renderWarningQueryResult.js.map